import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ChevronRight, Timer } from "lucide-react";
import api from "../lib/api";

/**
 * SpinBanner — top-of-feed pill inviting users to Spin & Win, with live
 * countdown to the next spell. Auto-hides if the API is down.
 */
export default function SpinBanner() {
  const [state, setState] = useState(null);
  const [nowSec, setNowSec] = useState(Math.floor(Date.now() / 1000));

  useEffect(() => {
    let alive = true;
    api.get("/spin/state").then(({ data }) => { if (alive) setState(data); }).catch(() => {});
    const t = setInterval(() => setNowSec(Math.floor(Date.now() / 1000)), 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!state) return null;

  const secsLeft = Math.max(0, (state.next_spell || 0) - nowSec);
  const h = Math.floor(secsLeft / 3600).toString().padStart(2, "0");
  const m = Math.floor((secsLeft % 3600) / 60).toString().padStart(2, "0");
  const s = (secsLeft % 60).toString().padStart(2, "0");

  return (
    <Link
      to="/spin"
      data-testid="spin-banner"
      className="flex items-center gap-2 px-3 py-2 rounded-full bg-gradient-to-r from-[#FF2A5F]/95 via-[#8B5CF6]/95 to-[#FF7A00]/95 border border-white/15 shadow-[0_6px_24px_rgba(255,42,95,0.35)] active:scale-[0.98] transition"
    >
      <div className="w-7 h-7 rounded-full bg-white/95 flex items-center justify-center flex-shrink-0">
        <Sparkles className="w-4 h-4 text-[#FF2A5F]"/>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-outfit font-extrabold text-white leading-tight">Spin & Win up to 100K Goldly</div>
        <div className="flex items-center gap-1 text-[10px] text-white/85 font-bold leading-tight">
          <span className="px-1.5 rounded bg-black/25 font-mono">{state.chances_remaining}</span>
          <span>spins left</span>
          <span className="text-white/50">·</span>
          <Timer className="w-2.5 h-2.5"/>
          <span className="font-mono">{h}:{m}:{s}</span>
        </div>
      </div>
      <ChevronRight className="w-4 h-4 text-white flex-shrink-0"/>
    </Link>
  );
}
